import React, { FC } from "react";
import cx from "classnames";

import { emptyCallback } from "~/util/emptyCallback";

import { FontSize, FontWeight, TypographyElement } from "./Typography.types";

export type TypographyProps = {
  size: FontSize;
  weight: FontWeight;
  element?: TypographyElement;
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
};

export const Typography: FC<TypographyProps> = ({
  children,
  size,
  weight,
  element: TypographyComponent = "span",
  className,
  disabled = false,
  onClick = emptyCallback,
  ...props
}) => {
  return (
    <TypographyComponent
      onClick={onClick}
      className={cx(className, `fs-${size} fw-${weight}`, {
        "opacity-50": disabled,
      })}
      {...props}
    >
      {children}
    </TypographyComponent>
  );
};
